import "../styles/SidepanelStyle.css";
import { filter_wms_by_boundary } from "./SidePanel";

import Select from "react-select";
import axios from "axios";

import { useState, useEffect } from "react";

const CountrySelection = ({
  countries_options,
  setCountries_options, //
  selected_country,
  setSelected_country,
  setCurrent_vector,
  setCurrent_spi,
  current_spi,
  get_filtered_wms_spi,
  get_filtered_wms,
  current_fapar_anomaly,
  base_url,
  current_fapar_absorbed,
  selected_region,
  setSelected_region,
  current_monthly_precipitation_gpcc,
  setCurrent_monthly_precipitation_gpcc,
  setCurrent_fapar_anomaly,
  setCurrent_fapar_absorbed,
  current_sma,
  setCurrent_sma,
  current_cdi,
  setCurrent_cdi,
  active_admin_boundaries, 
  setActive_admin_boundaries
}) => {
  const [region_options, setRegion_options] = useState([]);

  const [country_options, setCountry_options] = useState([]); // country options

  const [disable_region_selection, setDisable_region_selection] =
    useState(true);
  const [disable_country_selection, setDisable_country_selection] =
    useState(true);
  const [selected_region_name, setSelected_region_name] = useState(null);

  var maplibre_str =
    "bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&width=256&height=256&layers=";


  var africa_bounds = {
      maxx: 64,
      maxy: 38,
      minx: -26,
      miny: -45,
    };
  const get_data = async (url) => {
    const res = await axios.get(url);

    const data = res.data;
    return data;
  };

  function handle_wms_region(region_code) {
    // cdi
    if (current_cdi !== null) {
      var cdi_wms_link = filter_wms_by_boundary(
        current_cdi["cdi_geoserver"],
        region_code,
        "cell",
        0
      );
      setCurrent_cdi({ cdi_geoserver: cdi_wms_link });
    }
    // precipitation gpcc
    if (current_monthly_precipitation_gpcc !== null) {
      var gpcc_wms_link = filter_wms_by_boundary(
        current_monthly_precipitation_gpcc[
          "monthly_precipitation_gpcc_geoserver"
        ],
        region_code,
        "corr_cell",
        0
      );
      setCurrent_monthly_precipitation_gpcc({
        monthly_precipitation_gpcc_geoserver: gpcc_wms_link,
      });
    }
    // spi
    if (current_spi !== null) {
      var spi_wms_link = filter_wms_by_boundary(
        current_spi,
        region_code,
        "corr_cell",
        0
      );
      setCurrent_spi(spi_wms_link);
    }
    // fapar anomaly
    if (current_fapar_anomaly !== null) {
      var fapar_anomaly_wms_link = filter_wms_by_boundary(
        current_fapar_anomaly["fapar_anomaly_geoserver"],
        region_code,
        "cell",
        0
      );
      setCurrent_fapar_anomaly({
        fapar_anomaly_geoserver: fapar_anomaly_wms_link,
      });
    }
    // fapar absorbed
    if (current_fapar_absorbed !== null) {
      var fapar_absorbed_wms_link = filter_wms_by_boundary(
        current_fapar_absorbed["fapar_absorbed_geoserver"],
        region_code,
        "cell",
        0
      );
      setCurrent_fapar_absorbed({
        fapar_absorbed_geoserver: fapar_absorbed_wms_link,
      });
    }
    // sma
    if (current_sma !== null) {
      var sma_wms_link = filter_wms_by_boundary(
        current_sma["sma_geoserver"],
        region_code,
        "cell",
        0
      );
      setCurrent_sma({
        sma_geoserver: sma_wms_link,
      });
    }
  }

  function handle_wms_country(country_code) {
    if (current_cdi !== null) {
      var cdi_wms_link = filter_wms_by_boundary(
        current_cdi["cdi_geoserver"],
        country_code,
        "cell",
        1
      );
      setCurrent_cdi({ cdi_geoserver: cdi_wms_link });
    }

    // precipitation gpcc
    if (current_monthly_precipitation_gpcc !== null) {
      var gpcc_wms_link = filter_wms_by_boundary(
        current_monthly_precipitation_gpcc[
          "monthly_precipitation_gpcc_geoserver"
        ],
        country_code,
        "corr_cell",
        1
      );
      setCurrent_monthly_precipitation_gpcc({
        monthly_precipitation_gpcc_geoserver: gpcc_wms_link,
      });
    }
    // sma
    if (current_sma !== null) {
      var sma_wms_link = filter_wms_by_boundary(
        current_sma["sma_geoserver"],
        country_code,
        "cell",
        1
      );
      setCurrent_sma({
        sma_geoserver: sma_wms_link,
      });
    }
  }

  const onchange_region = (e) => {
    setDisable_country_selection(true);
    var region_code = countries_options["regions_info"][e.value]["region_code"];
    setSelected_region_name(e.value);
    setSelected_region(region_code);

    handle_wms_region(region_code);

    setCountry_options(
      countries_options["regions_info"][e.value]["country_code"]
    );

    var region_data = {
      region_code: countries_options["regions_info"][e.value]["region_code"],
      bounds: countries_options["regions_info"][e.value]["region_bounds"],
    };

    var current_vector_data = {
      url:
        countries_options["geoserver"]["wms"] +
        maplibre_str +
        countries_options["geoserver"]["layername"] +
        "&transparent=true&CQL_FILTER=region_code=" +
        region_data["region_code"],
      name: e.value,
      bounds: region_data["bounds"],
    };
    setCurrent_vector(current_vector_data);

    setDisable_country_selection(false);
    setSelected_country(null);
  
  };

  const onchange_country = (e) => {
    setSelected_country({ country_id: e.value["country_code"], name: e.label });
    var current_vector_data = {
      url:
        countries_options["geoserver"]["wms"] +
        maplibre_str +
        countries_options["geoserver"]["layername"] +
        "&transparent=true&CQL_FILTER=country_code=" +
        e.value["country_code"],
      name: e.label,
      bounds: e.value["country_bounds"],
    };
    var country_code = e.value["country_code"];
    if (current_spi !== null) {
      get_filtered_wms_spi(current_spi, country_code);
    }
    if (current_fapar_anomaly !== null) {
      get_filtered_wms(
        current_fapar_anomaly["fapar_anomaly_geoserver"],
        country_code
      );
    }
    if (current_fapar_absorbed !== null) {
      get_filtered_wms(
        current_fapar_absorbed["fapar_absorbed_geoserver"],
        country_code,
        "fapar_absorbed"
      );
    }
    handle_wms_country(e.value["country_code"]);

    setCurrent_vector(current_vector_data);
  };

  useEffect(() => {
    const get_countries_list_data = async () => {
      const countries_list_data = await get_data(
        `${base_url}/api/data_api/geojson/getgeojsoninfo?country_names=ALL`
      );
      setCountries_options(countries_list_data);
      setRegion_options(Object.keys(countries_list_data["regions_info"]));
    
      var current_vector_data = {
        url:
          `${countries_list_data["geoserver"]["wms"]}${maplibre_str}${countries_list_data["geoserver"]["layername"]}&transparent=true`,
        name: "africa",
        bounds: africa_bounds,
      };
      setCurrent_vector(current_vector_data);
      setDisable_region_selection(false);
    };

    get_countries_list_data();
  }, []);

  const customoptions = (anArray) => {
    var opt = anArray.map((item) => {
      return { value: item, label: item };
    });
    return opt;
  };

  const customoptions_countries = (anArray) => {
    var opt = anArray.map((item) => {
      return {
        value: {
          country_code: item["country_code"],
          country_bounds: item["country_bounds"],
          country_name: item["country_name"],
        },
        label: item["country_name"],
      }; //
    });
    return opt;
  };
// todo handle clipple wms on deselecting country and region
  const onclick_region = () =>{
    setSelected_region(null);
    setSelected_country(null);
    setDisable_country_selection(true);

    setCurrent_vector( pev =>( {
      ...pev,
      url: countries_options["geoserver"]["wms"] +
      maplibre_str +
      countries_options["geoserver"]["layername"] +
      "&transparent=true",
      name: "africa",
      bounds: africa_bounds,
    }));

  }

  const onclick_country = () => {
    setSelected_country(null);
    var wms_link = `${countries_options["geoserver"]["wms"]}${maplibre_str+countries_options["geoserver"]["layername"]}&transparent=true&CQL_FILTER=region_code=${selected_region}`;
   
    setCurrent_vector( pev => ({
      ...pev,
      url: wms_link,
      name: selected_region_name,
      bounds: countries_options["regions_info"][selected_region_name]["region_bounds"],
    }));
  
  }
  const oncheck_admin = () => {
    setActive_admin_boundaries(!active_admin_boundaries);
    
  };


  

  return (
    <div className="container" >
      
      <div className="columns">
            
          <div className="column">
                <p className="Names subtitle is-6   mb-2 has-text-weight-medium">Region</p>


            <Select
              className="select-text"
              classNamePrefix="select-controls"
              options={customoptions(region_options)}
              placeholder="Select Region"
              value="Select Region"
              onChange={onchange_region}
              // onSelectResetsInput="false"
              isSearchable={true}
              isDisabled={disable_region_selection}
            ></Select>
          </div>

          <div className="column">
                <p className="Names subtitle is-6  mb-2 has-text-weight-medium">Country</p>
                <Select
                className="select-text"
                classNamePrefix="select-controls"
                options={customoptions_countries(country_options)}
                placeholder="Select Country"
                value="Select Country"
                onChange={onchange_country}
                isSearchable={true}
                isDisabled={disable_country_selection}
              ></Select>
          </div>
            
        
      </div>
    
      <div className="columns delete-tags mb-1">

          {selected_region && <div className="column del-tag">
              <span className="tag">
                {selected_region_name}
                <button className="delete is-small del-tag" onClick={onclick_region}></button>
              </span>
            </div>}

          {selected_country && <div className="column">
              
          <span className="tag">
          {selected_country?.name}
            <button className="delete is-small del-tag" onClick={onclick_country}></button>
          </span>

            </div>}

      </div>
    
    </div>
  );
};

export default CountrySelection;
